'use client'
import { Navbar, NavbarBrand, NavbarContent, NavbarItem } from "@nextui-org/react";
import { usePathname } from 'next/navigation'

import { Route } from '../../../routers/routes';
import Link from 'next/link';
import { BRAND, COUNTRY_SWEDEN_ID, COUNTRY_UAE_ID } from "../../../data/constants";
import NavigationMe from "./NavigationMe";
import NextImage from "../images/NextImage";
import React, { Suspense } from "react";


export default function NavigationDefault(props) {
  const { countryId = COUNTRY_UAE_ID } = props
  const pathname = usePathname()

  const linkArrs = {
    [COUNTRY_UAE_ID]: [
      { name: 'Community', href: Route.UAEPortfolioList() },
      { name: 'Stocks', href: Route.instrumentList() },
      { name: 'Activity', href: Route.threadsAll() }
    ],
    [COUNTRY_SWEDEN_ID]: [
      // { name: 'Nyheter', href: Route.SVLandingPage() },
      { name: 'Artiklar', href: Route.EditorialContentList(COUNTRY_SWEDEN_ID) },
      { name: 'Aktier', href: Route.instrumentList(countryId) },
      // { name: 'Activity', href: Route.threadsAll() }
    ]
  }

  const linkArr = linkArrs[countryId]

  return (
    <div className="border-b-2 border-primary/10 bg-primary-900">
      <Navbar className="lg:container lg:mx-auto justify-stretch bg-inherit ">
        <NavbarBrand>
          <Link href={Route.loginRedirect(countryId)}>
            <div className="max-w-44">
              <NextImage 
                src={BRAND.brandNameAndSymbol} 
                alt={`${BRAND.name} logotype`} 
                className="hidden md:block" 
                style={{objectFit: 'contain', width: 'auto', height: 'auto'}} 
                width="200" 
                height="20" 
              />
            </div>
            <NextImage 
              src={BRAND.brandSymbol} 
              alt={`${BRAND.name} logotype`} 
              className="block md:hidden max-w-14" 
              style={{objectFit: 'contain', width: 'auto', height: 'auto'}} 
              width="56" 
              height="50" 
            />
          </Link>
        </NavbarBrand>
        <NavbarContent className="sm:flex gap-1" justify="center">
          {linkArr.map((link) => {
            const isActive = pathname.includes(link.href)
            return (
              <NavbarItem key={link.name} className={`text-sm px-2 md:px-4 py-2 font-semibold ${isActive ? 'text-primary-400 border-b-1 border-b-primary-400' : 'text-white '}`}>
                <Link href={link.href}>{link.name}</Link>
              </NavbarItem> 
            )
          })}
        </NavbarContent>
        <NavbarContent justify="end">
          <Suspense>
            <NavigationMe countryId={countryId} />
          </Suspense>
        </NavbarContent>
      </Navbar>
    </div>
  )
}
